import { createContext, useContext } from "react";

const RoundOverrideContext = createContext(null);

export const RoundOverrideProvider = ({ round, children }) => (
  <RoundOverrideContext.Provider value={round}>{children}</RoundOverrideContext.Provider>
);

export const useRoundOverride = () => useContext(RoundOverrideContext);
